import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const LibraryWiseInstituteList = Loadable(
  lazy(() => import("features/libraryWiseInstitute/components/List"))
);
const LibraryWiseInstitutePage = Loadable(
  lazy(() => import("features/libraryWiseInstitute/components/Page"))
);

const routes = {
  path: "libraryWiseInstitute",
  children: [
    { path: "", element: <LibraryWiseInstituteList /> },
    { path: "add", element: <LibraryWiseInstitutePage /> },
    {
      path: "edit/:libraryWiseInstituteId?",
      element: <LibraryWiseInstitutePage />,
    },
  ],
};

export default routes;
